module.exports = __webpack_public_path__ + "static/media/data-hero2-v2.ada6b366.png";